// If you want to add more then dont forget to add translation for admin

export const LESSON_TYPE: Record<string, string> = {
	1: 'Default',
	2: 'Information',
	3: 'Listened',
	4: 'Lesson',
	5: 'Test',
	6: 'Homework',
};
